import React from "react";

const SendV2Icon16pxSvg = ({
    color = "#1F2937",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M9.48 14.42C8.69334 14.42 7.58 13.8667 6.7 11.22L6.22 9.78005L4.78 9.30005C2.14 8.42005 1.58667 7.30671 1.58667 6.52005C1.58667 5.74005 2.14 4.62005 4.78 3.73338L10.44 1.84671C11.8533 1.37338 13.0333 1.51338 13.76 2.23338C14.4867 2.95338 14.6267 4.14005 14.1533 5.55338L12.2667 11.2134C11.38 13.8667 10.2667 14.42 9.48 14.42ZM5.09334 4.68671C3.24 5.30671 2.58 6.04005 2.58 6.52005C2.58 7.00005 3.24 7.73338 5.09334 8.34671L6.77334 8.90671C6.92 8.95338 7.04 9.07338 7.08667 9.22005L7.64667 10.9C8.26 12.7534 9 13.4134 9.48 13.4134C9.96 13.4134 10.6933 12.7534 11.3133 10.9L13.2 5.24005C13.54 4.21338 13.48 3.37338 13.0467 2.94005C12.6133 2.50671 11.7733 2.45338 10.7533 2.79338L5.09334 4.68671Z" fill={color} />
            <path d="M6.74003 9.60004C6.61337 9.60004 6.4867 9.55337 6.3867 9.45337C6.19337 9.26004 6.19337 8.94004 6.3867 8.74671L8.77337 6.35337C8.9667 6.16004 9.2867 6.16004 9.48003 6.35337C9.67337 6.54671 9.67337 6.86671 9.48003 7.06004L7.09337 9.45337C7.00003 9.55337 6.8667 9.60004 6.74003 9.60004Z" fill={color} />
        </svg>
    );
};

export default SendV2Icon16pxSvg;